import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstantsComponent } from '../shared/global-constants/global-constants.component';

@Injectable({
  providedIn: 'root'
})
export class HubspotService {
  private apiUrl = GlobalConstantsComponent.apiURL;
  private api2Url = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
  ) { }

  updateHubspotPartner(datas) {
    return this.http.post(`${this.api2Url}updateHubspotPartner`, datas);
  }
  updateRegistrationField(datas) {
    if (datas.field == 'phone' || datas.field ==  'whatsAppId'){
      datas.value = datas.value.internationalNumber;
    }
    return this.http.post(`${this.api2Url}hubspot/updateRegistrationField`, datas);
  }
  processTracking(datas) {
    return this.http.post(`${this.api2Url}hubspotProcessTracking`, datas);
  }
  updateHubspot(data){
    return this.http.post(`${this.api2Url}hubspot/update`, {data: data});
  }
}
